import * as Sentry from '@sentry/react';

import { AppConstants } from '@/app.constants';

export type HttpResponseDiagnostics = {
  method: string;
  url: string;
  status: number;
  requestId: string;
  responseTime: string | null;
};

function readHeader(headers: Headers, name: string): string | null {
  const value = headers.get(name);
  if (!value?.trim()) {
    return null;
  }
  return value.trim();
}

export function extractHttpResponseDiagnostics(input: {
  method: string;
  url: string;
  status: number;
  headers: Headers;
}): HttpResponseDiagnostics {
  const requestId =
    readHeader(input.headers, AppConstants.REQUEST_ID_HEADER) ??
    readHeader(input.headers, 'x-request-id') ??
    '';
  return {
    method: input.method,
    url: input.url,
    status: input.status,
    requestId,
    responseTime: readHeader(input.headers, 'x-response-time'),
  };
}

export function recordHttpResponseDiagnostics(diagnostics: HttpResponseDiagnostics): void {
  if (!Sentry.isInitialized()) {
    return;
  }
  if (diagnostics.requestId) {
    Sentry.setTag('request_id', diagnostics.requestId);
    Sentry.setContext('last_api_response', {
      request_id: diagnostics.requestId,
      'x-request-id': diagnostics.requestId,
      'x-response-time': diagnostics.responseTime,
      method: diagnostics.method,
      url: diagnostics.url,
      status: diagnostics.status,
    });
  }
  Sentry.addBreadcrumb({
    category: 'http',
    type: 'http',
    level: diagnostics.status >= 400 ? 'warning' : 'info',
    data: {
      method: diagnostics.method,
      url: diagnostics.url,
      status_code: diagnostics.status,
      request_id: diagnostics.requestId || undefined,
      response_time: diagnostics.responseTime ?? undefined,
    },
  });
}
